import {motion} from 'framer-motion';

export default function CoreCard ({ block, index, data: { title, content, img }}) {
  return (
    <motion.div
      className='flex flex-col lg:flex-row justify-center items-center lg:gap-x-[10%]'
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ amount: 0.3, once: true }}
    >
      <img
        className='w-full lg:w-1/2 aspect-[570/340] rounded-[12px] lg:rounded-[20px] bg-no-repeat bg-center bg-cover'
        src={`${process.env.REACT_APP_STATIC_URL}/images/Core/Image${block + 1}-${index + 1}.jpg`}
        alt={title}
      />

      <div className='mt-[28px] lg:w-[50%]'>
        <div className='font-bold text-heading2 lg:text-title2 text-label-300'>{title}</div>
        <div className='mt-[16px] lg:mt-[32px] text-body1 lg:text-heading1 text-label-100'>
          {content}
        </div>
      </div>
    </motion.div>
  )
}